module.exports = __webpack_public_path__ + "img/feat_1.8736d4eb.png";